// YERİ: src/app/domains/site/sections/practice-areas.section.ts
// Uygulama Alanları (avukatlık) — ikon + başlık + açıklama kart grid'i.
// config.items[] yoksa avukat default'larıyla render eder.

import { Component, computed, input } from '@angular/core';
import { MIcon } from '@/app/shared/ui/m-icon';
import { SiteConfig, cfg } from './section.model';

interface PracticeItem { icon?: string; title: string; description?: string; }

@Component({
  selector: 'sec-practice-areas',
  standalone: true,
  imports: [MIcon],
  template: `
    <section id="practice" class="bg-neutral-50 py-24 dark:bg-neutral-900">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <div class="mx-auto max-w-2xl text-center">
          <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p>
          <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">{{ title() }}</h2>
          @if (subtitle()) {
            <p class="mt-4 text-lg text-neutral-600 dark:text-neutral-400">{{ subtitle() }}</p>
          }
        </div>

        <div class="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          @for (item of items(); track item.title) {
            <div class="group relative rounded-2xl border border-neutral-200 bg-white p-7 transition hover:-translate-y-1 hover:shadow-xl dark:border-neutral-800 dark:bg-neutral-950">
              <div class="absolute left-0 top-7 h-9 w-1 rounded-r" style="background-color:var(--site-accent)"></div>
              <div class="flex size-12 items-center justify-center rounded-xl text-white" style="background-color:var(--site-primary)">
                <m-icon [name]="item.icon || 'scale'" size="md" />
              </div>
              <h3 class="mt-5 text-lg font-semibold text-neutral-900 dark:text-white">{{ item.title }}</h3>
              @if (item.description) {
                <p class="mt-2 text-sm leading-relaxed text-neutral-600 dark:text-neutral-400">{{ item.description }}</p>
              }
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class PracticeAreasSection {
  config = input<SiteConfig>({});
  protected eyebrow = computed(() => cfg(this.config(), 'eyebrow', 'Uzmanlık'));
  protected title = computed(() => cfg(this.config(), 'title', 'Uygulama Alanlarımız'));
  protected subtitle = computed(() => cfg(this.config(), 'subtitle', 'Geniş yelpazede hukuki hizmet sunarak haklarınızı en üst düzeyde koruyoruz.'));
  protected items = computed<PracticeItem[]>(() => cfg<PracticeItem[]>(this.config(), 'items', [
    { icon: 'briefcase', title: 'Ticaret Hukuku', description: 'Şirket kuruluşu, sözleşmeler, birleşme ve devralmalarda kurumsal danışmanlık.' },
    { icon: 'users', title: 'Aile Hukuku', description: 'Boşanma, velayet, nafaka ve mal paylaşımı süreçlerinde hassas temsil.' },
    { icon: 'scale', title: 'Ceza Hukuku', description: 'Soruşturma ve kovuşturma aşamalarında etkin savunma ve müdafilik.' },
    { icon: 'house', title: 'Gayrimenkul Hukuku', description: 'Tapu, kira, imar ve gayrimenkul uyuşmazlıklarında çözüm.' },
    { icon: 'file-text', title: 'İş Hukuku', description: 'İşçi-işveren ilişkileri, iş sözleşmeleri ve tazminat davaları.' },
    { icon: 'landmark', title: 'İcra & İflas', description: 'Alacak takibi, icra işlemleri ve iflas süreçlerinin yönetimi.' },
  ]));
}
